import clientConfigApi from '../../config/config'

export const confirmationPop = (status) => {
    return {
        type: 'Check_Out_Confirmation',
        payload: status
    }
}

export const SetSelectedGuest = (selectedGuest) => {
    return {
        type: 'Set_Selected_Guest',
        payload: selectedGuest
    }
}

export const setSuccessFailPop = (show, status, message) => {
    return {
        type: 'Set_Success_Fail_Pop_UP',
        payload: {
            show,
            status,
            message
        }
    }
}

export const sendGuestMail = (guestDetail, emailID) => {
    return async dispatch => {
        clientConfigApi.post(
            `/guestProfile/updateByLocationAndGuestToken`,
            {
                "header": {
                    "locationId": guestDetail.location,
                    "guestToken": guestDetail.guestToken
                },
                "payload": {
                    "emailId": emailID
                }
            }
        ).then((res) => {
            console.log("sendGuestMail success.", res);
        })
            .catch(
                (response) => {
                    console.log("send Guest Mail Api failed:", response);
                }
            )
    }
}